export const withQueryString = (url: string, params: URLSearchParams): string => {
  const query = params.toString();
  if (!query) {
    return url;
  }
  return `${url}?${query}`;
};
